// Laskutilaus (HubSpot-lomakkeen korvaaja, 14.9.2026). Kutsupaikat rakentavat tilauksen URL-parametreiksi kuten
// ennenkin (hubspotForms.appendInvoiceOrderParams + omat kentät); avaus tapahtuu appin sisäisessä modaalissa
// (InvoiceOrderModal, Sidebarissa) uuden välilehden sijaan. Yksi tapahtuma, jotta neljä kutsupaikkaa pysyvät yhden rivin muutoksina.
export const INVOICE_ORDER_EVENT = 'tendera:invoice-order';

export const openInvoiceOrder = (url) => {
    window.dispatchEvent(new CustomEvent(INVOICE_ORDER_EVENT, { detail: { url: String(url) } }));
};

// URL-parametrit → tilaus + esitäyttö. Parametrinimet ovat samat kuin HubSpot-lomakkeen aikana.
export const parseInvoiceOrderUrl = (url) => {
    const p = new URL(url).searchParams;
    const g = (k) => p.get(k) || '';
    return {
        order: {
            planId: g('planId'), planName: g('planName') || g('tenderapaketti'), billingInterval: g('billingInterval') || g('laskutusjakso'),
            price: g('price'), currency: g('currency') || 'EUR', monthlyPrice: g('monthlyPrice'), yearlyPrice: g('yearlyPrice'),
            maxUsers: g('maxUsers'), extraSeats: g('extraSeats') || g('lisakayttajapaikat') || '0',
            upgrade: Object.fromEntries([...p.entries()].filter(([k]) => k.startsWith('upgrade_'))),
        },
        contact: {
            name: [g('firstname'), g('lastname')].filter(Boolean).join(' '), email: g('email') || g('contact_email'), phone: g('phone'),
            company: g('company'), businessId: g('0-2/y_tunnus') || g('business_code') || g('vat'),
            address: g('address'), zip: g('zip'), city: g('city'), country: g('country') || g('country_code'),
            organizationId: g('organization_id'),
        },
    };
};
